import type * as React from "react";
import {
  Sidebar as SidebarUI,
  SidebarContent,
  SidebarRail,
} from "@/_old/components/ui/sidebar";
import { useAuth } from "@/core/components/auth/store/auth";
import { useSidebar } from "@/_old/components/ui/sidebar";
import { SidebarFooter } from "./components/sidebar-footer";
import { SidebarMenu } from "./components/sidebar-menu";
import { SidebarContentHeader } from "./components/sidebar-content-header";
import { SidebarHeader } from "./components/sidebar-header";

export function Sidebar({ ...props }: React.ComponentProps<typeof SidebarUI>) {
  const { userInfo } = useAuth();

  const { state } = useSidebar();

  if (!userInfo || !userInfo.user) {
    return null;
  }

  const hideText = state === "collapsed";

  return (
    <SidebarUI {...props} collapsible="icon" className="border-none">
      <SidebarHeader />

      <SidebarContent className={`py-4 ${hideText ? "px-2" : "px-4"}`}>
        <SidebarContentHeader />

        <SidebarMenu />
      </SidebarContent>

      <SidebarFooter />

      <SidebarRail />
    </SidebarUI>
  );
}
